import { WidgetTypeWithSuffix } from '@/shared/components/Mosaic'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { widgetWindowsSelector } from '../widgetWindowsSelector'
import { replaceAllWidgetWindows } from '../widgetWindowsSlice'

type SyncWithMosaicStatePayload = {
  mosaicNodes: WidgetTypeWithSuffix[]
}

export const syncWithMosaicState = createAsyncThunk<void, SyncWithMosaicStatePayload, ThunkApiContext>('widgetWindows/syncWithMosaicState',
  async ({ mosaicNodes }, { dispatch, getState }) => {
    const state = getState()
    const widgetWindows = widgetWindowsSelector.selectEntities(state)

    const updatedWidgetWindows = mosaicNodes.map(node => {
      return widgetWindows[node]
    })
    
    dispatch(replaceAllWidgetWindows(updatedWidgetWindows))
  },
)
